import { createCustomEnum } from "../customEnum";

const AchBoardingStatusTypes = createCustomEnum({
	Pending: {
		value: 0,
		name: "pending",
		displayName: "Pending",
	},
	Complete: {
		value: 2,
		name: "complete",
		displayName: "Complete",
	},
	Rejected: {
		value: 1,
		name: "rejected",
		displayName: "Rejected",
	},
});

export default AchBoardingStatusTypes;
